/**
 * @desc 组织模块
 */
const agencyList = r => require.ensure([],() => r(require('../views/organization/AgencyList.vue')) ,'agencyList');

const bureauList = r => require.ensure([],() => r(require('../views/organization/BureauList.vue')) ,'bureauList');

const schoolList = r => require.ensure([],() => r(require('../views/organization/SchoolList.vue')) ,'schoolList');

//课程方管理
const institutionList = r => require.ensure([],() => r(require('../views/organization/InstitutionList.vue')) ,'institutionList');

//角色管理
const roleList = r => require.ensure([],() => r(require('../views/organization/RoleList.vue')) ,'roleList');

//权限管理
const permissionList = r => require.ensure([],() => r(require('../views/organization/PermissionList.vue')) ,'permissionList');

const termList = r => require.ensure([],() => r(require('../views/organization/TermList.vue')) ,'termList');

//教学设置
const bureauSetting = r => require.ensure([],() => r(require('../views/organization/BureauSetting.vue')) ,'bureauSetting');



export default [
  //代理列表
  {
    name: 'agencyList',
    path: '/agencyList',
    component: agencyList,
    meta: {title: '代理列表'},
  },
  //教育局列表
  {
    name: 'bureauList',
    path: '/bureauList',
    component: bureauList,
    meta: {title: '教育局列表'},
  },
  //学校列表
  {
    name: 'schoolList',
    path: '/schoolList',
    component: schoolList,
    meta: {title: '学校列表'},
  },
  //课程方管理列表
  {
    name: 'institutionList',
    path: '/institutionList',
    component: institutionList,
    meta: {title: '课程方管理列表'},
  },
  //j角色管理
  {
    name: 'roleList',
    path: '/roleList',
    component: roleList,
    meta: {title: '角色管理列表'},
  },
  //权限管理
  {
    name: 'permissionList',
    path: '/permissionList',
    component: permissionList,
    meta: {title: '权限管理列表'},
  },
  //学期管理列表
  {
    name: 'termList',
    path: '/termList',
    component: termList,
    meta: {title: '学期管理'},
  },
  //教学设置
  {
    name: 'bureauSetting',
    path: '/bureauSetting',
    component: bureauSetting,
    meta: {title: '教学设置'},
  },
  
]